<template>
	<div class="trusted">
		{{ t('trusted_by', { count: '244,518' }) }}
	</div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.trusted {
	color: #666260;
}
</style>
